/* Luxury Decors UAE - Theme JS */
document.addEventListener('DOMContentLoaded', function() {
  // QTY CONTROLS
  document.querySelectorAll('[data-qty-minus]').forEach(btn => {
    btn.addEventListener('click', function() {
      const wrap = this.closest('[data-qty-wrap]');
      const val = wrap.querySelector('[data-qty-val]');
      const input = wrap.querySelector('input[name="quantity"]');
      let n = parseInt(val.textContent) || 1;
      if (n > 1) { n--; val.textContent = n; if (input) input.value = n; }
    });
  });
  document.querySelectorAll('[data-qty-plus]').forEach(btn => {
    btn.addEventListener('click', function() {
      const wrap = this.closest('[data-qty-wrap]');
      const val = wrap.querySelector('[data-qty-val]');
      const input = wrap.querySelector('input[name="quantity"]');
      let n = parseInt(val.textContent) || 1;
      n++; val.textContent = n; if (input) input.value = n;
    });
  });
  // PDP TABS
  document.querySelectorAll('.ld-pdp__tab').forEach(tab => {
    tab.addEventListener('click', function() {
      const panel = this.dataset.panel;
      document.querySelectorAll('.ld-pdp__tab').forEach(t => t.classList.remove('active'));
      document.querySelectorAll('.ld-pdp__panel').forEach(p => p.classList.remove('active'));
      this.classList.add('active');
      const target = document.getElementById('panel-' + panel);
      if (target) target.classList.add('active');
    });
  });
  // PDP IMAGE THUMBNAILS
  document.querySelectorAll('.ld-pdp__thumb').forEach(thumb => {
    thumb.addEventListener('click', function() {
      document.querySelectorAll('.ld-pdp__thumb').forEach(t => t.classList.remove('active'));
      this.classList.add('active');
      const mainImg = document.querySelector('.ld-pdp__main-img img');
      const src = this.querySelector('img') && this.querySelector('img').src;
      if (mainImg && src) mainImg.src = src;
    });
  });
  // STICKY HEADER
  const header = document.querySelector('.ld-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.style.boxShadow = window.scrollY > 10 ? '0 2px 20px rgba(0,0,0,.1)' : '0 1px 12px rgba(0,0,0,.06)';
    });
  }
  // ADD TO CART FEEDBACK
  document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
    btn.addEventListener('click', function() {
      const orig = this.textContent;
      this.textContent = 'Added!';
      this.style.background = '#2D7A4A';
      this.style.color = '#fff';
      const badge = document.querySelector('.ld-nav__badge');
      if (badge) badge.textContent = parseInt(badge.textContent || 0) + 1;
      setTimeout(() => { this.textContent = orig; this.style.background = ''; this.style.color = ''; }, 2000);
    });
  });
  // SCROLL ANIMATIONS
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.style.opacity='1'; entry.target.style.transform='translateY(0)'; observer.unobserve(entry.target); }
      });
    }, { threshold: 0.1 });
    document.querySelectorAll('.ld-prod-card, .ld-cat-pill, .ld-story__feat').forEach(el => {
      el.style.opacity='0'; el.style.transform='translateY(16px)'; el.style.transition='opacity .4s ease, transform .4s ease';
      observer.observe(el);
    });
  }
});